/*
 * Public API Surface of ng-select
 */

export { NgSelectComponent, SELECTION_MODEL_FACTORY } from './lib/ng-select.component';
export { NgSelectModule } from './lib/ng-select.module';
export { NgOption, DropdownPosition } from './lib/ng-select.types';
export { SelectionModel } from './lib/selection-model';
export { NgSelectConfig } from './lib/config.service';
export { NgOptionComponent } from './lib/ng-option.component';
export {
    NgOptgroupTemplateDirective,
    NgOptionTemplateDirective,
    NgFooterTemplateDirective,
    NgHeaderTemplateDirective,
    NgItemLabelDirective,
    NgLabelTemplateDirective,
    NgLoadingSpinnerTemplateDirective,
    NgLoadingTextTemplateDirective,
    NgMultiLabelTemplateDirective,
    NgNotFoundTemplateDirective,
    NgTagTemplateDirective,
    NgTypeToSearchTemplateDirective
} from './lib/ng-templates.directive';
